import { render, staticRenderFns } from "./IndividualK.vue?vue&type=template&id=587e22b6&scoped=true"
import script from "./IndividualK.vue?vue&type=script&lang=js"
export * from "./IndividualK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587e22b6",
  null
  
)

export default component.exports